module.exports = __webpack_public_path__ + "static/media/a39.98018156.jpg";